export async function fetchAllActivities() {
  try {
    const response = await fetch('/admin/activities', {
      method: 'GET',
      credentials: 'include',
    });
    return await response.json();
  } catch (err) {
    console.error("[fetchAllActivities] - Error fetching data:", err);
    return [];
  }
}

export async function fetchAllStories() {
  try {
    const response = await fetch('/admin/stories', {
      method: 'GET',
      credentials: 'include',
    });
    return await response.json();
  } catch (err) {
    console.error("[fetchAllStories] - Error fetching data:", err);
    return [];
  }
}

export async function fetchAllLetters() {
  try {
    const response = await fetch('/admin/letters', {
      method: 'GET',
      credentials: 'include',
    });
    return await response.json();
  } catch (err) {
    console.error("[fetchAllLetters] - Error fetching data:", err);
    return [];
  }
} 